<template>
  <div>
    <canvas :id="id"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
import lodash from "lodash";

export default {
  name: "BarGraph",
  props: {
    data: {
      type: Array,
    },
    id: {
      type: String,
    },
  },
  data() {
    return {
      labels: [],
      dataSet: [],
      borders: [],
      palette: [],
           colors: ['#a6cee3','#1f78b4','#b2df8a','#33a02c','#fb9a99','#e31a1c','#fdbf6f','#ff7f00','#cab2d6','#6a3d9a','#ffff99','#b15928','#8dd3c7','#ffffb3','#bebada','#fb8072','#80b1d3','#fdb462','#b3de69','#fccde5','#d9d9d9','#bc80bd','#ccebc5','#ffed6f']

    };
  },
  mounted() {
    let sortedArray = lodash.orderBy(this.data, "count", "desc");
    this.labels = sortedArray.map((item) => item.title);
    this.dataSet = sortedArray.map((item) => item.count);
    this.createChart(this.id);
  },
  computed: {
    options() {
      return {
        aspectRatio: 1,
        responsive: true,
        legend: {
          position: "left",
          align: "start",
          fontColor: "white",
          fontSize: 18,
          labels: {
            fontColor: "white",
            padding: 9,
          },
        },
        title: {
          display: false,
          text: "Chart.js Doughnut Chart",
        },
      };
    },
  },
  methods: {
    createChart(chartId) {
      const ctx = document.getElementById(chartId);
      new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: this.labels,
          datasets: [
            {
              label: "Test",
              data: this.dataSet,
              backgroundColor: this.colors,
              borderColor: "black",
              borderWidth: 0,
            },
          ],
        },
        options: this.options,
      });
    },
  },
};
</script>
